export const RouterName = {
  auth: {
    login: "/auth/login",
    signup: "",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password/:token",
    maintenance: "/auth/maintenance",
  },
  admins: {
    admins: "/admins",
    privileges: "/privileges",
  },
  users: {
    users: "/users",
    user_details: "/users",
  },

  settings: {
    settings: "/settings",
    settings_details: "/settings/details",
  },

  legal_information: {
    legal_information: "/legal_information",
  },

  events: {
    events: "/events",
  },
  founders: {
    founders: "/founders",
  },
  bars: {
    bars: "/bars",
  },

  bar_images: {
    bar_images: "/bar_images/:id",
  },
  quotation: {
    quotation: "/quotation",
  },
  menu: {
    menu: "/menu",
  },
  menu_cocktails: {
    menu_cocktails: "/menu_cocktails/:id",
  },

  quotation: {
    quotation: "/quotation"
  },

  seo: {
    seo: "/seo",
  },

  services: {
    services: "/services",
  },
  service_images: {
    service_images: "/service_images/:id",
  },
  stations: {
    stations: "/stations",
  },
  station_images: {
    station_images: "/station_images/:id",
  },

  contact: {
    contact: "/contact",
  },

  event_img: {
    event_img: "/event_img/:id",
  },
  event_images: {
    event_images: "/event_images",
  },

  banners: {
    banners: "/banners",
  },

  clients: {
    clients: "/clients",
  },


  admins_logs: {
    admins_logs: "/logs",
  },

  categories: {
    categories: "/categories",
  },
  items: {
    items: "/items",
  },
  item_gallery: {
    item_gallery: "/item_gallery/:id",
  },
  orders: {
    orders: "/orders",
  },
  countries: {
    countries: "/countries",
  },
  areas: {
    areas: "/areas/:id",
  },
  dashboard: {
    dashboard: "/dashboard",
  },
};
